var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rn-footer position"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(" © 2020-"+_vm._s(new Date().getFullYear())+" sunyung.cn 版权所有 ICP证： 浙ICP备2022023544号-2 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }